/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
  name: "ShellModal",
  components: {
    customModal,
  },
  emits: ["closeModal", "saved"],
  props: {
    editingId: {
      type: String,
      default: null,
    },
    nextVersionData: {
      type: Object,
      default: null,
    },
    reportId: {
      type: String,
      default: "",
    },
    programId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      studyId: "",
      studyVersion: "",
      isEditMode: false,
      loading: false,

      newShell: {
        shellName: "",
        shellVersion: "",
        fontFamily: "",
        fontSize: null,
        orientation: "",
        orientationHeight: null,
        orientationWidth: null,
        marginTop: null,
        marginBottom: null,
        marginLeft: null,
        marginRight: null,
        titleText: "",
        titleBold: false,
        titleAlign: "left",
      },

      headerBorderBottom: true,
      headerRows: [{ left: "", center: "", right: "" }],
      maxHeaderRows: 3,

      footerBorderTop: true,
      footerRows: [{ left: "", center: "", right: "" }],
      maxFooterRows: 3,

      tokenOptions: [],

      errors: {
        shellName: false,
        shellVersion: false,
      },
      errorMessages: {
        shellName: "",
        shellVersion: "",
      },
    };
  },

  computed: {
    titleTokenOptions: function () {
      return this.tokenOptions.filter(function (item) {
        return item.label === "Programme Title";
      });
    },
  },

  watch: {
    footerRows: {
      deep: true,
      handler: function (rows) {
        var footnoteValue = null;
        var found = this.tokenOptions.find(function (opt) {
          return opt.label.toLowerCase().replace(/\s/g, "") === "footnote";
        });
        if (found) footnoteValue = found.value;
        if (!footnoteValue) return;
        rows.forEach(function (row) {
          if (row.left !== footnoteValue) return;
          row.center = "";
          row.right = "";
        });
      },
    },
  },

  async created() {
    this.token = store.getters.getIdToken;
    this.studyId = store.getters.getStudyIs;
    this.studyVersion = store.getters.getStudyVersion;
    // If programId is set, clear reportId to avoid mixed-level shell operations
    if (this.programId) {
      console.log("[ShellModal] Program selected, clearing reportId to use program-level only");
      // Internally ignore reportId; don't mutate the prop
    }
    await this.fetchTokenOptions();
    await this.loadModalData();
  },

  methods: {
    async fetchTokenOptions() {
      try {
        var res = await axios.get(
          `${this.baseurl}/stats-python/shellconfig/tokens`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.tokenOptions = res.data.tokens || [];
        console.log("[ShellModal] Token options loaded:", this.tokenOptions);
      } catch (err) {
        console.error("[ShellModal] Failed to fetch token options:", err);
        this.tokenOptions = [];
      }
    },

    clearErrors() {
      this.errors.shellName = false;
      this.errors.shellVersion = false;
      this.errorMessages.shellName = "";
      this.errorMessages.shellVersion = "";
    },

    isFootnoteSelected(row) {
      var found = this.tokenOptions.find(function (opt) {
        return opt.label.toLowerCase().replace(/\s/g, "") === "footnote";
      });
      var footnoteValue = found ? found.value : null;
      return row.left === footnoteValue;
    },

    handleFooterSelection(row, position) {
      var found = this.tokenOptions.find(function (opt) {
        return opt.label.toLowerCase().replace(/\s/g, "") === "footnote";
      });
      var footnoteValue = found ? found.value : null;
      if (!footnoteValue) return;
      if (row[position] === footnoteValue && row.left !== footnoteValue) {
        alert("Please fill footnote in left");
        row[position] = "";
      }
    },

    validate() {
      var isValid = true;
      this.clearErrors();
      if (!this.newShell.shellName || !this.newShell.shellName.trim()) {
        this.errors.shellName = true;
        this.errorMessages.shellName = "Please enter shell name";
        isValid = false;
      }
      if (!this.newShell.shellVersion || !this.newShell.shellVersion.trim()) {
        this.errors.shellVersion = true;
        this.errorMessages.shellVersion = "Please enter shell version";
        isValid = false;
      }
      return isValid;
    },

    async loadModalData() {
      if (!this.token || !this.studyId) return;

      // Case 1: Add New Version — nextVersionData passed from parent
      if (this.nextVersionData) {
        this.isEditMode = false;
        var data = this.nextVersionData.data || this.nextVersionData;
        console.log("[ShellModal] Setting version from nextVersionData:", data);
        this.prefillForm(data);
        this.newShell.shellVersion = this.getShellVersion(data);
        this.isEditMode = false;
        return;
      }

      // Case 2: Edit existing shell
      if (this.editingId) {
        this.isEditMode = true;
        try {
          var res = await axios.get(
            `${this.baseurl}/stats-python/shellconfig/${this.editingId}`,
            { headers: { Authorization: `Bearer ${this.token}` } }
          );
          var shellData = res.data.data || res.data;
          this.prefillForm(shellData);
        } catch (err) {
          console.error("[ShellModal] Failed to load shell data:", err);
        }
        return;
      }

      // Case 3: Create brand new shell
      this.isEditMode = false;
      this.resetForm();
    },

    normalizeToken(val) {
      if (!val) return "";
      var exact = this.tokenOptions.find(function (opt) {
        return opt.value === val;
      });
      if (exact) return exact.value;
      var partial = this.tokenOptions.find(function (opt) {
        return opt.value && val.includes(opt.value);
      });
      if (partial) return partial.value;
      return val;
    },

    getShellVersion(data) {
      if (!data) return "";
      var source = data.data || data.result || data;
      var nested =
        source.next_version ||
        source.nextVersionData ||
        source.nextVersion ||
        source.shell ||
        source;
      return (
        source.Version ||
        source.version ||
        source.shellVersion ||
        source.ShellVersion ||
        source.NextVersion ||
        source.nextVersion ||
        nested.Version ||
        nested.version ||
        nested.shellVersion ||
        nested.ShellVersion ||
        nested.NextVersion ||
        nested.nextVersion ||
        ""
      );
    },

    prefillForm(data) {
      console.log("[ShellModal] prefillForm called with:", data);

      var font = data.Font || {};
      var pageLayout = data.PageLayout || {};
      var title = data.Title || {};

      this.newShell = {
        shellName: data.TemplateName || "",
        shellVersion: this.getShellVersion(data),
        fontFamily: font.family || "",
        fontSize: font.sizePt !== undefined ? font.sizePt : null,
        orientation: pageLayout.orientation || "",
        orientationHeight: pageLayout.heightMm !== undefined ? pageLayout.heightMm : null,
        orientationWidth: pageLayout.widthMm !== undefined ? pageLayout.widthMm : null,
        marginTop: pageLayout.marginTopMm !== undefined ? pageLayout.marginTopMm : null,
        marginBottom: pageLayout.marginBottomMm !== undefined ? pageLayout.marginBottomMm : null,
        marginLeft: pageLayout.marginLeftMm !== undefined ? pageLayout.marginLeftMm : null,
        marginRight: pageLayout.marginRightMm !== undefined ? pageLayout.marginRightMm : null,
        titleText: (title.lines && title.lines.length > 0) ? title.lines[0] : "",
        titleBold: title.bold !== undefined ? title.bold : false,
        titleAlign: title.align || "left",
      };

      var header = data.Header || {};
      this.headerBorderBottom = header.borderBottom !== false;
      this.headerRows = (header.rows && header.rows.length > 0)
        ? header.rows.map(function (r) {
          return {
            left: this.normalizeToken(r.left),
            center: this.normalizeToken(r.center),
            right: this.normalizeToken(r.right),
          };
        }.bind(this))
        : [{ left: "", center: "", right: "" }];

      var footer = data.Footer || {};
      this.footerBorderTop = footer.borderTop !== false;
      this.footerRows = (footer.rows && footer.rows.length > 0)
        ? footer.rows.map(function (r) {
          return {
            left: this.normalizeToken(r.left),
            center: this.normalizeToken(r.center),
            right: this.normalizeToken(r.right),
          };
        }.bind(this))
        : [{ left: "", center: "", right: "" }];

      console.log("[ShellModal] newShell after prefill:", this.newShell);
    },

    addHeaderRow() {
      if (this.headerRows.length < this.maxHeaderRows)
        this.headerRows.push({ left: "", center: "", right: "" });
    },
    removeHeaderRow() {
      if (this.headerRows.length > 1) this.headerRows.pop();
    },
    addFooterRow() {
      if (this.footerRows.length < this.maxFooterRows)
        this.footerRows.push({ left: "", center: "", right: "" });
    },
    removeFooterRow() {
      if (this.footerRows.length > 1) this.footerRows.pop();
    },

    async submitShell() {
      if (!this.validate()) return;

      console.log("[ShellModal] Submitting shell - programId:", this.programId, "reportId:", this.reportId);

      // Duplicate version check
      try {
        var duplicateCheckUrl = this.programId
          ? `${this.baseurl}/stats-python/shellconfig/program-list/${this.studyId}/${this.programId}`
          : this.reportId
            ? `${this.baseurl}/stats-python/shellconfig/report-list/${this.studyId}/${this.reportId}`
            : `${this.baseurl}/stats-python/shellconfig/study/${this.studyId}`;
        console.log("[ShellModal] Duplicate check URL:", duplicateCheckUrl);
        var checkRes = await axios.get(
          duplicateCheckUrl,
          { headers: { Authorization: `Bearer ${this.token}` } }
        );
        var duplicateData = checkRes.data && checkRes.data.data !== undefined
          ? checkRes.data.data
          : checkRes.data;
        var existingShells = Array.isArray(duplicateData)
          ? duplicateData
          : duplicateData && duplicateData._id
            ? [duplicateData]
            : [];

        if (this.programId) {
          existingShells = existingShells.filter(function (s) {
            var pid = s.ProgramId || s.Programid || s.ProgramID || s.programId || s.programid || s.program_id || s.ProgrammeId || s.programmeId || s.SourceId || s.Sourceid || s.sourceId || s.sourceid || "";
            return pid && String(pid).trim().toLowerCase() !== "null" && String(pid).trim().toLowerCase() !== "undefined";
          });
        } else if (this.reportId) {
          existingShells = existingShells.filter(function (s) {
            var rid = s.ReportId || s.Reportid || s.reportId || "";
            var pid = s.ProgramId || s.Programid || s.ProgramID || s.programId || s.programid || s.program_id || s.ProgrammeId || s.programmeId || s.SourceId || s.Sourceid || s.sourceId || s.sourceid || "";
            var hasReport = rid && String(rid).trim().toLowerCase() !== "null" && String(rid).trim().toLowerCase() !== "undefined";
            var hasProgram = pid && String(pid).trim().toLowerCase() !== "null" && String(pid).trim().toLowerCase() !== "undefined";
            return hasReport && !hasProgram;
          });
        } else {
          existingShells = existingShells.filter(function (s) {
            var rid = s.ReportId || s.Reportid || s.reportId || "";
            var pid = s.ProgramId || s.Programid || s.ProgramID || s.programId || s.programid || s.program_id || s.ProgrammeId || s.programmeId || s.SourceId || s.Sourceid || s.sourceId || s.sourceid || "";
            var hasReport = rid && String(rid).trim().toLowerCase() !== "null" && String(rid).trim().toLowerCase() !== "undefined";
            var hasProgram = pid && String(pid).trim().toLowerCase() !== "null" && String(pid).trim().toLowerCase() !== "undefined";
            return !hasReport && !hasProgram;
          });
        }

        var enteredVersion = this.newShell.shellVersion.trim().toLowerCase();
        var versionMatch = existingShells.find(function (s) {
          return s.Version && s.Version.trim().toLowerCase() === enteredVersion;
        });
        if (versionMatch) {
          alert(
            `Version "${this.newShell.shellVersion}" already exists. Please use a different version.`
          );
          return;
        }
      } catch (err) {
        console.warn("[ShellModal] Could not fetch shell list for duplicate check:", err);
      }

      var payload = {
        StudyId: this.studyId,
        ReportId: this.programId ? null : (this.reportId || null),
        ProgramId: this.programId ? null : null,
        SourceId: this.programId || null,
        TemplateName: this.newShell.shellName,
        Version: this.newShell.shellVersion,
        IsDefault: this.programId ? true : false,

        Font: {
          family: this.newShell.fontFamily || "monospace",
          sizePt: this.newShell.fontSize ? Number(this.newShell.fontSize) : 10,
        },

        PageLayout: {
          orientation: this.newShell.orientation || "",
          widthMm: this.newShell.orientationWidth ? Number(this.newShell.orientationWidth) : 0,
          heightMm: this.newShell.orientationHeight ? Number(this.newShell.orientationHeight) : 0,
          marginTopMm: this.newShell.marginTop !== null ? Number(this.newShell.marginTop) : 0,
          marginBottomMm: this.newShell.marginBottom !== null ? Number(this.newShell.marginBottom) : 0,
          marginLeftMm: this.newShell.marginLeft !== null ? Number(this.newShell.marginLeft) : 0,
          marginRightMm: this.newShell.marginRight !== null ? Number(this.newShell.marginRight) : 0,
        },

        Title: {
          lines: this.newShell.titleText ? [this.newShell.titleText] : [],
          bold: this.newShell.titleBold,
          align: this.newShell.titleAlign || "left",
        },

        Header: {
          borderBottom: this.headerBorderBottom,
          rows: this.headerRows.map(function (row, i) {
            return {
              rowIndex: i,
              left: row.left || "",
              center: row.center || "",
              right: row.right || "",
            };
          }),
        },

        Footer: {
          borderTop: this.footerBorderTop,
          rows: this.footerRows.map(function (row, i) {
            return {
              rowIndex: i,
              left: row.left || "",
              center: row.center || "",
              right: row.right || "",
            };
          }),
        },
      };

      try {
        console.log("[ShellModal] POST payload:", JSON.stringify(payload, null, 2));
        await axios.post(
          `${this.baseurl}/stats-python/shellconfig/`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );
        alert("Shell created successfully");
        this.$emit("saved");
        this.closeModal();
      } catch (err) {
        var status = err.response ? err.response.status : null;
        var errData = err.response ? err.response.data : null;
        console.error("[ShellModal] HTTP Status:", status);
        console.error("[ShellModal] Full error detail:", JSON.stringify(errData, null, 2));

        var errStr = JSON.stringify(errData || "").toLowerCase();
        var isDuplicate =
          status === 409 ||
          (status === 400 &&
            (errStr.includes("already exists") ||
              errStr.includes("duplicate") ||
              errStr.includes("version")));

        if (isDuplicate) {
          alert(
            `A shell named "${this.newShell.shellName}" with version "${this.newShell.shellVersion}" already exists. Please use a different version.`
          );
          return;
        }

        if (errData && errData.detail) {
          alert("Validation Error:\n" + JSON.stringify(errData.detail, null, 2));
        } else {
          var backendMessage = errData && errData.messages && errData.messages[0]
            ? errData.messages[0]
            : "Shell creation failed";
          alert(backendMessage);
        }
      }
    },

    closeModal() {
      this.$emit("closeModal");
    },

    resetForm() {
      this.newShell = {
        shellName: "",
        shellVersion: this.studyVersion || "",
        fontFamily: "",
        fontSize: null,
        orientation: "",
        orientationHeight: null,
        orientationWidth: null,
        marginTop: null,
        marginBottom: null,
        marginLeft: null,
        marginRight: null,
        titleText: "",
        titleBold: false,
        titleAlign: "left",
      };
      this.headerBorderBottom = true;
      this.headerRows = [{ left: "", center: "", right: "" }];
      this.footerBorderTop = true;
      this.footerRows = [{ left: "", center: "", right: "" }];
      this.isEditMode = false;
      this.clearErrors();
    },
  },
};
